<app-static-pages-header [title]="'Allgemeine Einstellbedingungen (AEB)'"></app-static-pages-header>
<div class="container anb">
  <div class="row justify-content-md-center">
    <div class="col-md-8">
      <h2 class="main__title">Allgemeine Einstellbedingungen</h2>
      <ol class="app__justify-text">
        <li>
          <h5>Geltungsbereich der AEB</h5>
          <ol>
            <li>
              Die SFA Sport GmbH („SFA“) erbringt ihre Leistungen gegenüber dem Kunden
              ausschließlich auf der Grundlage der nachfolgenden Allgemeinen Einstellbedingungen
              (AEB). Die folgenden Allgemeinen Einstellbedingungen (AEB) gelten für alle
              Geschäftsbeziehungen zwischen
              <ul style="margin-bottom: 8px">
                <li>SFA einerseits und dem Kunden andererseits und</li>
                <li>dem Kunden einerseits und dem Nutzer andererseits.</li>
              </ul>
            </li>
            <li>
              <p>
                Maßgeblich ist jeweils die zum Zeitpunkt des Vertragsschlusses gültige Fassung.
                Abweichende, entgegenstehende oder ergänzende Allgemeine Geschäftsbedingungen
                (AGB) des Kunden werden, selbst bei Kenntnis, nicht Vertragsbestandteil, es sei denn,
                SFA hätte ihrer Geltung ausdrücklich schriftlich zugestimmt.
              </p>
            </li>
            <li>
              AGB des Kunden widerspricht SFA ausdrücklich.
            </li>
            <li>
              Änderungen der AEB werden dem Kunden bekannt gegeben und gelten als vereinbart,
              wenn der Kunde den geänderten AEB nicht schriftlich binnen 14 Tagen widerspricht; auf
              die Bedeutung des Schweigens wird der Kunde in der Verständigung ausdrücklich
              hingewiesen.
            </li>
            <li>
              Die vorliegenden AEB richten sich vorrangig an Unternehmen im Sinne des § 1 Abs 2
              KSchG.
            </li>
          </ol>
        </li>
        <li>
          <h5>Über SFA</h5>
          <ol>
            <li>
              SFA stellt Akteuren des österreichischen Amateurfußballs eine „Medienplattform“ zur
              Abrufbarhaltung von Informationen über den Verein, dessen Leistungen und Neuigkeiten
              zur Verfügung.
            </li>
            <li>
              Vertragsgegenständlich sind die Abrufbarhaltung von vom Kunden oder seinen
              Funktionären oder Erfüllungsgehilfen selbst eingegeben Informationen.
            </li>
            <li>
              Die Services werden von SFA in Form einer „Software as a Service“-Lösung (SaaS)
              bereitgestellt. Vertragsgegenständlich ist die Bereitstellung des Zugangs zu diesen
              Services. Die Software und die Apps stehen in ihrer Gesamtheit im Eigentum von SFA
              und sind urheberrechtlich geschützt. Dem Kunden werden (mit Ausnahme an den Apps,
              siehe dazu Punkt 2.6) keinerlei Lizenzrechte an der dem Service zugrunde liegenden
              Software eingeräumt.
            </li>
            <li>
              Der Kunde ist Medieninhaber in Bezug auf jene Veröffentlichungen, die er selbst
              verwaltet, SFA ist technischer Verbreiter und Host.
            </li>
            <li>
              SFA wird den Nutzern die Services der Plattform zum Abruf bereithalten und die Apps
              zum kostenlosen Download anbieten, wodurch auch ein gesondertes
              Registrierungsverhältnis zwischen dem Nutzer und SFA entsteht, dem SFA eigene
              Nutzungsbedingungen zugrunde legt.
            </li>
            <li>
              Beim Download der App durch den Nutzer gelten ferner die Allgemeinen
              Geschäftsbedingungen des Online-Shops (z.B. Apple App Store, Google Play), auf die
              SFA keinen Einfluss hat. Die Bedingungen des Downloads der Apps werden am
              Bildschirm des Endgerätes ausgewiesen. Die Apps können erforderlich sein, um die
              Services voN SFA nutzen zu können. Der Nutzer erwirbt das nicht ausschließliche,
              jedoch zeitlich und örtlich unbeschränkte Recht, eine Kopie der App für seine eigenen
              Zwecke auf seinem Endgerät zu speichern.
            </li>
          </ol>
        </li>
        <li>
          <h5>Registrierung</h5>
          <ol>
            <li>
              SFA lädt den Kunden durch Bereitstellung einer Abfragemaske ein, sich grundsätzlich
              kostenlos für die Nutzung der Plattform zu registrieren.
            </li>
            <li>
              Der Kunden hat zu diesem Zweck die vorgesehene Abfragemaske vollständig und
              richtig auszufüllen und ausdrücklich die AEB in der gültigen Fassung zu akzeptieren. Die
              vom Kunden bekannt gegebenen Daten sind vom ihm während des aufrechten
              Registrierungsverhältnisses aktuell zu halten.
            </li>
            <li>
              Mit der vollständigen Registrierung erklärt der Kunden verbindlich sein Vertragsangebot
              zur Nutzung der Plattform, das von der SFA durch Übermittlung einer
              Registrierungsbestätigung per E-Mail angenommen werden kann.
            </li>
            <li>
              Dem Kunden obliegt die Sicherung und Geheimhaltung der Zugangsdaten zu seinem
              personalisierten Bereich.
            </li>
            <li>
              Es besteht kein Anspruch auf Registrierung. SFA behält sich vor,
              Registrierungsanfragen des Kunden grundlos abzulehnen.
            </li>
            <li>
              Der Kunde hat keinen Anspruch auf die Bereitstellung der Services durch SFA. SFA
              behält sich vor, die Service jederzeit (ganz oder teilweise) einzustellen, zu adaptieren
              oder kostenlose Services kostenpflichtig zu stellen.
            </li>
            <li>
              Der Kunde kann Funktionäre oder Fans, im Folgenden kurz „Erfüllungsgehilfen“, als
              „Teamreporter“ anmelden und diese damit ermächtigen, in seinem Namen Inhalte (im
              Folgenden kurz: „Content“ wie Lichtbilder, Text, Logos, Videos, Grafiken usw.) zum
              Abruf bereit zu halten. Er haftet für die Handlungen seiner Erfüllungsgehilfen wie für
              seine eigenen. Es besteht kein Anspruch auf Freischaltung, SFA behält sich vor, die
              Ermächtigung jederzeit zu widerrufen.
            </li>
          </ol>
        </li>
        <li>
          <h5>Leistungen von SFA</h5>
          <ol>
            <li>
              Vertragsgegenständlich ist die Abrufbarhaltung von Content über den Kunden auf der fan.at-Plattform.
            </li>
            <li>
              SFA stellt dem Kunden einen persönlichen Online-Zugang (Webinterface) zur Verfügung, um seinen Content
              auf der Plattform einzupflegen und abrufbar halten zu können.
            </li>
            <li>
              SFA trifft über die Abrufbarhaltung des Contents hinaus keine Vermarktungsverpflichtung für den Content.
            </li>
            <li>
              Die Vertragsparteien sind verpflichtet, sich bei der Bewerbung der vertragsgemäßen Einschaltungen zu unterstützen.
            </li>
            <li>
              SFA wird die Services laufend warten und funktionsfähig halten. Dem Kunden steht aber kein Anspruch auf ein
              bestimmtes Update oder Upgrade zu.
            </li>
          </ol>
        </li>
        <li>
          <h5>Rechte und Pflichten des Kunden</h5>
          <ol>
            <li>
              Der Kunden verpflichtet sich, auf der Plattform aktuellen und wahrheitsgemäßen Content einzupflegen und diesen
              Content im laufenden Vertragsverhältnis aktuell zu halten.
            </li>
            <li>
              Der Kunde verpflichtet sich, die Plattform nur unter Einhaltung der gesetzlichen Bestimmungen in Anspruch zu
              nehmen und jedwede missbräuchliche Inanspruchnahme zu unterlassen.
            </li>
            <li>
              Der Kunde garantiert SFA, bei Nutzung der vertragsgegenständlichen Leistungen gegen keine Rechte zu
              verstoßen, insbesondere Verletzungen von Urheberrechten, Marken- und
              sonstigen Kennzeichenrechten, des Gesetzes gegen den unlauteren Wettbewerb, Persönlichkeitsrechten und
              gewerblichen Schutzrechten zu unterlassen. Im Falle eines Verstoßes gegen diese Garantien hat der Kunde
              SFA schad- und klaglos zu halten.
            </li>
            <li>
              Die Übermittlung von Inhalten des Kunden hat online in elektronischer Form zu erfolgen. Erfolgt die Übergabe auf
              einer Hardcopy (CD, DVD, USB-Stick usw.), so geht das Eigentum an der Hardcopy auf SFA über.
            </li>
          </ol>
        </li>
        <li>
          <h5>Rechte und Pflichten von SFA</h5>
          <ol>
            <li>
              SFA ist berechtigt, aber nicht verpflichtet, den Content zu kontrollieren und nicht sinnverändernde
              Änderungen, insbesondere zur Beseitigung von Tippfehlern, vorzunehmen.
            </li>
            <li>
              Der Kunde nimmt zur Kenntnis, dass die Plattform für die Anforderungen und Bedürfnisse der Allgemeinheit
              erstellt wird. SFA übernimmt keine Gewähr und Haftung für die inhaltliche Richtigkeit, Aktualität, Fehlerfreiheit
              oder Vollständigkeit der angebotenen Dienste, sowie für eine bestimmt Verwendbarkeit. SFA haftet dem Kunden nicht
              für eine allfällige Unterbrechung, Störung, Verspätung, Löschung, Fehlübertragung, oder einen Speicherausfall im
              Zusammenhang mit der Inanspruchnahme der Plattform.
            </li>
            <li>
              Der Kunde nimmt zur Kenntnis, dass die von SFA angebotenen Dienste auch unter Einbeziehung dritter Netzbetreiber und
              (Social-)Media-Kanäle angeboten werden. Die Verfügbarkeit der Dienste ist deshalb von der technischen Bereitstellung
              fremder Dienste abhängig, auf die SFA keinen Einfluss hat.
            </li>
            <li>
              SFA ist berechtigt, die Dienste aus internen Gründen, etwa zu Wartungszwecken, für eine kurze, angemessene Zeit zu
              unterbrechen. Der Kunde kann daraus keine Ansprüche ableiten, SFA wird im Gegenzug auf eine schnelle Störungsbeseitigung
              hinwirken.
            </li>
          </ol>
        </li>
        <li>
          <h5>Dauer/Auflösung</h5>
          <ol>
            <li>
              Sofern keine ausdrückliche Einstelldauer vereinbart wurde, erfolgt der Vertragsabschluss
              unbefristet. Der unbefristete Einstellvertrag kann von jeder Vertragspartei unter
              Einhaltung einer Kündigungsfrist von 2 Wochen zum Ende eines vorausbezahlten
              Zeitraums, liegt dieser nicht vor, zum Ende eines Kalendermonats ohne Angabe von Gründen
              schriftlich (E-Mail oder Telefax genügt) gekündigt werden.
            </li>
            <li>
              Ausdrücklich befristete Einstellverträge können während der Vertragslaufzeit von jeder
              Vertragspartei nur aus wichtigem Grund gekündigt werden.
            </li>
            <li>
              Diese Regelung gilt auch dann, wenn der Kunde (insbesondere im Zusammenhang mit einer
              Paketbuchung) einer Mindestbezugsdauer (= Kündigungsverzicht) zugestimmt hat. Die Vereinbarung
              einer Mindestbezugsdauer stellt keine Befristung dar und lässt den Leistungsbezug über den
              Zeitraum des Mindestbezuges weiterlaufen.
            </li>
          </ol>
        </li>
        <li>
          <h5>Einschaltungsentgelt</h5>
          <ol>
            <li>
              Die Basis-Einschaltung des Kunden ist grundsätzlich kostenlos.
            </li>
            <li>
              Bei den Preisangaben für <u>Zusatzleistungen</u> handelt es sich, sofern nicht anders
              angegeben, um Netto-Einschaltungsentgelte je Monat und Profil zuzüglich der Umsatzsteuer
              in gesetzlicher Höhe.
            </li>
            <li>
              Das monatliche Einschaltungsentgelt für Zusatzleistungen wird, sofern nichts anderes vereinbart
              wurde, monatlich im Voraus zum Tag des Vertragsbeginns zur Zahlung fällig.
            </li>
            <li>
              Gewährt SFA Rabatte auf Paketbuchungen mit einer fixen Laufzeit, so tritt die Fälligkeit für
              das gesamte Paket, soferne nichts anderes vereinbart wurde, am Tag des Vertragsabschlusses ein.
            </li>
            <li>
              Das jährliche Einschaltungsentgelt wird gemäß dem von der Statistik Austria veröffentlichten VPI
              2015 wertgesichert. Ausgangsbasis ist die für den Monat des Vertragsabschlusses verlautbarte
              Indexzahl, Berechnungsbasis für das zukünftige Entgelt die jeweils für den Monat September des laufenden
              Jahres verlautbarte Indexzahl. DieVertragsparteien sind berechtigt, einmal jährlich schriftlich
              (E-Mail genügt) und mit Wirkung ausschließlich für die Zukunft, frühestens aber ab dem 1. Januar, eine
              Anpassung des Einschaltungsentgelts zu verlangen.
            </li>
          </ol>
        </li>
        <li>
          <h5>Zahlungen</h5>
          <ol>
            <li>
              Rechnungen von SFA sind umgehend zur Zahlung fällig.
            </li>
            <li>
              Bei Zahlungsverzug des Kunden gelten die gesetzlichen Verzugszinsen in der für Unternehmergeschäfte geltenden
              Höhe. Weiters verpflichtet sich der Kunde für den Fall des Zahlungsverzugs, SFA die entstehenden Mahn-
              und Inkassospesen, soweit sie zur zweckentsprechenden
              Rechtsverfolgung notwendig sind, zu ersetzen. Das umfasst jedenfalls
              die Kosten zweier Mahnschreiben je € 25,00 sowie die tariflichen Kosten eines Mahnschreibens eines mit
              der Eintreibung beauftragten Rechtsanwalts. Die Geltendmachung
              weitergehender Rechte und Forderungen bleibt davon unberührt.
            </li>
            <li>
              Im Falle des Zahlungsverzuges des Kunden kann SFA sämtliche erbrachten Leistungen und Teilleistungen
              sofort fällig stellen. Weiters ist SFA nicht verpflichtet, weitere Leistungen bis zur Begleichung
              des aushaftenden Betrages zu erbringen.
            </li>
            <li>
              Wurde die Bezahlung in Raten vereinbart, so behält sich SFA für den Fall der nicht fristgerechten
              Zahlung von Teilbeträgen oder Nebenforderungen das Recht vor, die sofortige Bezahlung der gesamten
              noch offenen Schuld zu fordern (Terminverlust).
            </li>
          </ol>
        </li>
        <li>
          <h5>Vom Kunden bereitgestellter Content</h5>
          <ol>
            <li>
              SFA räumt dem Kunden die Möglichkeit ein, eigenen „Content“ (wie Lichtbilder, Videos, Grafiken, Logos,
              Texte usw.) einzustellen und damit in einem interessierten Forum zu veröffentlichen. Für den Content
              ist der jeweilige Kunde selbst verantwortlich. In Bezug auf diesen Content kommt SFA die Rolle eines
              rein technischen Verbreiters/Hosts zu, der auf den verbreiteten Content des Kunden keinen Einfluss
              nimmt und diesen auch nicht beaufsichtigt. Eine Verantwortlichkeit von SFA kann gemäß § 16 Abs 1 ECG
              erst dann eintreten, wenn er von einem rechtswidrigen Content Kenntnis hat und diesen nicht unverzüglich
              nach Kenntniserlangung entfernt/sperrt.
            </li>
            <li>
              Der Kunde räumt SFA für die Dauer der jeweils geltenden gesetzlichen Schutzfrist an dem von ihm
              eingestellten Content ein geographisch und sachlich unbeschränktes, übertragbares, nicht-exklusives
              Verwertungs-, Nut-zungs- und Bearbeitungsrecht, insbesondere zu Zwecken der Abrufbarhaltung, Veröffentlichung
              und Verbreitung über die Plattform ein. Die Rechte umfassen insbesondere auch die
              Verwertung des Contents zur Bewerbung der Plattform, von Produkten und
              Dienstleistungen von SFA. SFA ist nicht verpflichtet, die Inhalte abrufbar zu
              halten; er kann den Content des Kunden jederzeit zurückweisen, an einem
              anderen Ort veröffentlichen, kürzen oder löschen.
            </li>
            <li>
              Der Kunde sagt SFA ausdrücklich zu, keinen Content einzustellen, dessen Bereitstellung, Veröffentlichung
              oder Nutzung gegen geltendes Recht verstößt oder Rechte Dritter (insbesondere Urheberrechte des
              Fotografen, Persönlichkeitsrechte des Abgebildeten und den Datenschutz von Betroffenen) verletzt und ihm die
              Nutzungsrechte zur nicht bloß vorübergehenden Vervielfältigung, Verbreitung und Abrufbarhaltung zustehen.
              Ausdrücklich untersagt ist die Einstellung von rassistischen, pornographischen, menschenverachtenden, beleidigenden
              und gegen die guten Sitten verstoßenden Contents.
            </li>
            <li>
              Behauptet ein Dritter, durch den Inhalt in seinen Rechten verletzt worden zu sein, so ist SFA berechtigt, die
              vom Kunden bekannten Kontaktdaten bekannt zu geben.
            </li>
          </ol>
        </li>
        <li>
          <h5>Kennzeichnung, Referenz</h5>
          <ol>
            <li>
              SFA ist vorbehaltlich des jederzeit möglichen, schriftlichen Widerrufs des Kunden dazu berechtigt, auf
              eigenen Werbeträgern und insbesondere auf ihrer Internet-Website mit Namen und Firmenlogo auf die
              Geschäftsbeziehung zum Kunden hinzuweisen (Referenzhinweis).
            </li>
          </ol>
        </li>
        <li>
          <h5>Gewährleistung/Haftung</h5>
          <ol>
            <li>
              Für ihre eigenen Dienste (nicht aber für den Content) leistet SFA Gewähr im Sinne der
              Bestimmungen der §§ 922 ff ABGB.
            </li>
            <li>
              Die Haftung von SFA und die ihrer Organe, Angestellten, Kunden oder sonstigen Erfüllungsgehilfen
              („Leute“) ist im Grunde nach auf Vorsatz oder grobe Fahrlässigkeit beschränkt; die Haftung für
              leichte Fahrlässigkeit ist ausgeschlossen. Dieser Haftungsausschluss gilt nicht für Personenschäden
              und Schäden an Sachen, die SFA zur Bearbeitung übernommen hat. Soweit die Haftung von SFA ausgeschlossen
              oder beschränkt ist, gilt dies auch für die persönliche Haftung ihrer „Leute“.
            </li>
            <li>
              Die Services basieren größtenteils auf einer Eigenentwicklung von SFA und wird dem Kunden „as is“ zur
              Verfügung gestellt. SFA macht keinerlei ausdrückliche Zusagen für eine bestimmte Funktionalität oder
              Interoperabilität mit bestehenden oder zukünftigen Bedürfnissen des Kunden. SFA erbringt sämtliche Services
              jeweils nach Maßgabe der bestehenden technischen, wirtschaftlichen, betrieblichen und organisatorischen Möglichkeiten.
            </li>
          </ol>
        </li>
        <li>
          <h5>Datenschutz</h5>
          <ol>
            <li>
              SFA erklärt, das österreichische/europäische Datenschutzrecht einzuhalten und den Kunden und Nutzern
              ausreichend Gewähr für eine rechtmäßige und sichere Datenverarbeitung zu bieten.
            </li>
            <li>
              Der Datenverarbeitung durch SFA liegt die ausführliche „Datenschutzinformation“ zugrunde.
            </li>
          </ol>
        </li>
        <li>
          <h5>Sonstiges</h5>
          <ol>
            <li>
              Sollten einzelne Bestimmungen der AEB oder des Einstellvertrages ganz oder teilweise
              unwirksam sein oder werden, oder sollte sich in dem Vertrag eine Lücke befinden, so
              sollhierdurch die Gültigkeit der übrigen Bestimmungen nicht berührt werden.
            </li>
            <li>
              Änderungen und Ergänzungen der AEB oder des Einstellvertrages bedürfen der Schriftform. Das
              gilt auch für ein Abgehen von dem Schriftformerfordernis. Erklärungen per E-Mail oder
              Telefax entsprechen der Schriftform.
            </li>
            <li>
              Sollten in diesen AEB oder anderen Verträgen auf natürliche Personen bezogene
              Bezeichnungen nur in männli-cher Form angeführt sein, beziehen sie sich auf Frauen und
              Männer in gleicher Weise. Bei der Anwendung der Bezeichnung auf bestimmte natürliche
              Personen ist die jeweils geschlechtsspezifische Form zu verwenden.
            </li>
          </ol>
        </li>
        <li>
          <h5>Anwendbares Recht/Gerichtsstand/Erfüllungsort</h5>
          <ol>
            <li>
              Auf dieses Vertragsverhältnis findet materielles österreichisches Recht unter
              Ausschluss der Verweisungsnor-men Anwendung.
            </li>
            <li>
              Als Gerichtstand für alle sich mittelbar oder unmittelbar aus dem Vertrag ergebenden
              Streitigkeiten wird das für Graz örtlich und sachlich zuständige österreichische
              Gericht vereinbart.
            </li>
            <li>
              Der Erfüllungsort für die vertragsgegenständlichen Leistungen ist in Graz.
            </li>
          </ol>
        </li>
      </ol>
      <p>Stand: 07.10.2020</p>
    </div>
  </div>
</div>

